var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 67.995,
    viewBox: "0 0 72 67.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0,
    cy: 0.936,
    r: 2.66,
    gradientTransform: "matrix(0.977, -0.213, 0.061, 0.281, -0.058, 0.673)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfcf22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#cfcf22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#cfcf22",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcf22",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(-150.985 -407.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M2313,2579h0v-8.465c14.846-.229,26.923-11.682,26.923-25.531s-12.077-25.3-26.923-25.53V2511a38.456,38.456,0,0,1,14.031,2.789,36.551,36.551,0,0,1,11.441,7.308,33.831,33.831,0,0,1,7.7,10.759,32,32,0,0,1,0,26.282,33.829,33.829,0,0,1-7.7,10.759,36.56,36.56,0,0,1-11.441,7.308A38.465,38.465,0,0,1,2313,2579Z",
    transform: "translate(-2126.016 -2103.95)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3-2",
    "data-name": "Subtraction 3",
    d: "M2313,2579h0v-8.465c14.846-.229,26.923-11.682,26.923-25.531s-12.077-25.3-26.923-25.53V2511a38.456,38.456,0,0,1,14.031,2.789,36.551,36.551,0,0,1,11.441,7.308,33.831,33.831,0,0,1,7.7,10.759,32,32,0,0,1,0,26.282,33.829,33.829,0,0,1-7.7,10.759,36.56,36.56,0,0,1-11.441,7.308A38.465,38.465,0,0,1,2313,2579Z",
    transform: "translate(2499.984 2986.049) rotate(180)",
    opacity: 0,
    fill: "url(#radial-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.8fd58b88c2d861058c38898018d7862f.svg";
export { ForwardRef as ReactComponent };